import { notificationsSelectOneObjectByQuery } from "@common-reducers/DBServiceThunks";
import { useAppSelector } from '@common-reducers/hooks/store.hook';
import { NotificationStack } from './notification-row';

type Props = {
    notificationId: string;
}

export default function RenameNotification({
    notificationId,
}: Props) {
    const notification = useAppSelector((state) => notificationsSelectOneObjectByQuery(state.DBNotificationsReducer, {
        _id: notificationId,
        deleted: false
    }))

    if (!notification) {
        return null;
    }

    return (
        <NotificationStack direction='row'>
            {/* <div> */}
                {notification.actionType}&nbsp;
                <b>{notification.oldValue}</b>{` `}
                &nbsp;to&nbsp;
                <b>{notification.newValue}</b>{` `}
            {/* </div> */}
        </NotificationStack>
    )
}